"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _reactUse = require("react-use");

var _queryString = _interopRequireDefault(require("query-string"));

var _connectedReactRouter = require("connected-react-router");

var _usePageTitle = require("../hooks/usePageTitle");

var _url = require("../../constants/url.constants");

var _user = require("../../Shared/store/user/user.selectors");

var _useGetCampaignId = require("../hooks/useGetCampaignId");

var _Layout = _interopRequireDefault(require("./Layout"));

var _WhiteBirdLogo = _interopRequireDefault(require("./WhiteBirdLogo/WhiteBirdLogo"));

var _SelectCampaignStep = _interopRequireDefault(require("./SelectCampaignStep/SelectCampaignStep"));

var _AddRecipientStep = _interopRequireDefault(require("./AddRecipientStep/AddRecipientStep"));

var _CopyLinkStep = _interopRequireDefault(require("./CopyLinkStep/CopyLinkStep"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      zIndex = _ref.zIndex,
      breakpoints = _ref.breakpoints;
  return {
    header: {
      fontSize: 32,
      width: '100%',
      color: palette.common.white
    },
    subHeader: {
      fontSize: 16,
      width: '100%',
      color: palette.common.white
    },
    contentWrapper: {
      zIndex: zIndex.mobileStepper + 10,
      position: 'relative'
    },
    flexRow: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: 960,
      [breakpoints.down('xs')]: {
        flexWrap: 'wrap'
      }
    },
    flexRowCell: {
      flex: '1 1 auto',
      maxWidth: 360,
      [breakpoints.down('xs')]: {
        maxWidth: '100%'
      }
    },
    flexRowSpacing: {
      [breakpoints.up('sm')]: {
        width: 30
      }
    },
    mobileDivider: {
      [breakpoints.up('sm')]: {
        display: 'none'
      }
    },
    scrollToTop: {
      color: palette.common.white,
      [breakpoints.up('sm')]: {
        display: 'none'
      }
    }
  };
});

var GiftingOnTheFly = function GiftingOnTheFly() {
  var classes = useStyles();

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useLocation = (0, _reactUse.useLocation)(),
      _useLocation$search = _useLocation.search,
      search = _useLocation$search === void 0 ? '' : _useLocation$search;

  (0, _usePageTitle.useGiftingOnTheFlyTitle)();
  var campaignId = (0, _useGetCampaignId.useGetCampaignId)();
  var userId = (0, _reactRedux.useSelector)(_user.getUserId);
  (0, _react.useEffect)(function () {
    trackEvent('Gifting on the fly - Visited', {
      app: 'Gifting on the fly',
      campaignId
    });
  }, [trackEvent, campaignId]);
  (0, _react.useEffect)(function () {
    var _qs$parse = _queryString.default.parse(search),
        utmSource = _qs$parse.utm_source;

    if (utmSource === _url.SHORTCUT_HOSTNAME && userId) {
      trackEvent('alyce.gift - Visited', {
        userId
      });
      dispatch((0, _connectedReactRouter.replace)({
        search: ''
      }));
    }
  }, [trackEvent, userId, search, dispatch]);
  var scrollToTop = (0, _react.useCallback)(function () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Layout.default, null, /*#__PURE__*/_react.default.createElement(_WhiteBirdLogo.default, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.header
  }, "Gifting on the Fly"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.subHeader
  }, "By Alyce")), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 6,
    mb: 3
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 9,
    className: classes.flexRowCell
  }, /*#__PURE__*/_react.default.createElement(_SelectCampaignStep.default, null)), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mb: 3,
    className: classes.mobileDivider
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.flexRow
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 9,
    className: classes.flexRowCell
  }, /*#__PURE__*/_react.default.createElement(_AddRecipientStep.default, null)), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mb: 3,
    className: classes.mobileDivider
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.flexRowSpacing
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 9,
    className: classes.flexRowCell
  }, /*#__PURE__*/_react.default.createElement(_CopyLinkStep.default, null))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: scrollToTop,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-up"
    }),
    className: classes.scrollToTop
  }, "Scroll to top"))));
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftingOnTheFly);

exports.default = _default;